import immutable from 'immutable'
import { FLEETACT } from '../actiontype'
const defaultState = immutable.fromJS({
    // 车队是否配置活动
    activityConfig:false,
    // 车队总体完成情况
    activityOverAllFlag : false,
    // 车队今日完成情况
    toDayActivityFlag: false,
    // 司机激活条件，完单数量
    activateCondition : 0,
    // 司机完成人数
    activateCountReality : 0,
    // 司机目标人数
    activateCountTarget : 0,
    // 奖励金额
    awardMoney : 0,
    // 奖励金额计算方式百分比
    awardRule : 0,

    // 今日人均完单子数是否考核
    driverAcceptOrderFlag : true,

    // 今日人均完单子数
    driverAcceptOrderReality :0,
    // 今日人均完单子目标数
    driverAcceptOrderTarget :0,

    // 车队总人数是否考核
    fleetCountFlag : true,
    // 车队实际人数
    fleetCountReality : 0,
    // 车队总人数目标人数
    fleetCountTarget : 0,

    // 在线时长是否考核
    onlineTimeFlag : true,
    // 在线实际
    onlineTimeReality:0,
    // 在线目标
    onlineTimeTarget:0,

    // 人均流水是否考核
    payableAmountFlag:true,
    // 人均流水实际
    payableAmountReality:0,
    // 人均流水目标
    payableAmountTarget:0,

    // 车队达成天数
    reachDayReality	: 0,
    // 车队达成目标天数
    reachDayTarget : 0,

    // 车队完成天数某天完成情况
    taskReachDayList:[]
})

export const fleetactReducer = (state = defaultState, action) => {
    switch (action.type) {
        case FLEETACT:
            return state.updateIn(['activateCondition'], _ => (action.data.activateCondition))
                        .updateIn(['activateCountReality'], _ => (action.data.activateCountReality))
                        .updateIn(['activateCountTarget'], _ => (action.data.activateCountTarget))

                        .updateIn(['awardMoney'], _ => (action.data.awardMoney))
                        .updateIn(['awardRule'], _ => (action.data.awardRule))

                        .updateIn(['driverAcceptOrderFlag'], _ => (action.data.driverAcceptOrderFlag))
                        .updateIn(['driverAcceptOrderReality'], _ => (action.data.driverAcceptOrderReality))
                        .updateIn(['driverAcceptOrderTarget'], _ => (action.data.driverAcceptOrderTarget))

                        .updateIn(['fleetCountFlag'], _ => (action.data.fleetCountFlag))
                        .updateIn(['fleetCountReality'], _ => (action.data.fleetCountReality))
                        .updateIn(['fleetCountTarget'], _ => (action.data.fleetCountTarget))

                        .updateIn(['onlineTimeFlag'], _ => (action.data.onlineTimeFlag))
                        .updateIn(['onlineTimeReality'], _ => (action.data.onlineTimeReality))
                        .updateIn(['onlineTimeTarget'], _ => (action.data.onlineTimeTarget))

                        .updateIn(['payableAmountFlag'], _ => (action.data.payableAmountFlag))
                        .updateIn(['payableAmountReality'], _ => (action.data.payableAmountReality))
                        .updateIn(['payableAmountTarget'], _ => (action.data.payableAmountTarget))

                        .updateIn(['reachDayReality'], _ => (action.data.reachDayReality))
                        .updateIn(['reachDayTarget'], _ => (action.data.reachDayTarget))
                        .updateIn(['taskReachDayList'], _ => (action.data.taskReachDayList))

                        .updateIn(['activityOverAllFlag'], _ => (action.data.activityOverAllFlag))
                        .updateIn(['toDayActivityFlag'], _ => (action.data.toDayActivityFlag))

                        .updateIn(['activityConfig'], _ => (action.data.activityConfig))
                        
                        

        default:
            break;
    }
    return state
}
